import React from 'react';
import { getDefaultClient } from 'connectkit';
import { chain, configureChains, createClient, WagmiConfig } from 'wagmi';
import { alchemyProvider } from 'wagmi/providers/alchemy';

const WagmiProvier = ({ children }) => {
  const alchemyId = process.env.REACT_APP_ALCHEMY_KEY;

  const { provider, chains } = configureChains(
    [chain.goerli],
    [
      alchemyProvider({ apiKey: alchemyId }),
      // jsonRpcProvider({
      //   rpc: (chain) => {
      //     if (chain.id !== BSC_CHAIN.id) return null;
      //     return { http: chain.rpcUrls.default3 };
      //   },
      // }),
    ]
  );

  const client = createClient(
    getDefaultClient({
      appName: 'WOJ',
      alchemyId,
      provider,
      chains,
    })
  );

  return <WagmiConfig client={client}>{children}</WagmiConfig>;
};

export default WagmiProvier;
